import { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DateTimePicker from "@mui/lab/DateTimePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import Stack from "@mui/material/Stack";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export default function FormDialog({ open, handleClose }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [date, setDate] = useState(new Date());

  const [category, setCategory] = useState("");

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullScreen={fullScreen}>
        <DialogTitle>Filtrar SONVIs</DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack spacing={4}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Categoría</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={category}
                  label="Categoría"
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <MenuItem value={"Sonidos Naturales"}>
                    Sonidos Naturales
                  </MenuItem>
                  <MenuItem value={"Sonidos humanos"}>Sonidos humanos</MenuItem>
                  <MenuItem value={"Sonidos mecánicos"}>
                    Sonidos mecánicos
                  </MenuItem>
                  <MenuItem value={"Sonidos y sociedad"}>
                    Sonidos y sociedad
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <Stack spacing={4}>
                  <DateTimePicker
                    label="Inicio de rango"
                    value={date}
                    onChange={(e) => setDate(e)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  <DateTimePicker
                    label="Fin de rango"
                    value={date}
                    onChange={(e) => setDate(e)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Stack>
              </FormControl>
              <Button variant="contained" onClick={() => {}}>
                Cargar SONVI
              </Button>
            </Stack>
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleClose}>Subscribe</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
